/**
 * Sidebar navigation icons — stroke SVGs for dark nav
 */

const svg = (paths, viewBox = '0 0 20 20') =>
    `<svg class="crm-nav-svg" width="20" height="20" viewBox="${viewBox}" fill="none" aria-hidden="true">${paths}</svg>`;

export const NAV_ICONS = {
    deals: svg('<path d="M10 3.5L15.5 7v6L10 16.5 4.5 13V7L10 3.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>'),
    dashboard: svg(
        '<rect x="3.5" y="3.5" width="5.5" height="5.5" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
        '<rect x="11" y="3.5" width="5.5" height="5.5" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
        '<rect x="3.5" y="11" width="5.5" height="5.5" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
        '<rect x="11" y="11" width="5.5" height="5.5" rx="1" stroke="currentColor" stroke-width="1.4"/>'
    ),
    revenue: svg(
        '<rect x="4" y="6" width="10" height="9" rx="1.2" stroke="currentColor" stroke-width="1.4"/>' +
        '<path d="M6.5 6V5a2.5 2.5 0 015 0v1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
        '<rect x="7" y="4" width="9" height="9" rx="1.2" stroke="currentColor" stroke-width="1.4" opacity="0.55"/>'
    ),
    forecast: svg('<path d="M3.5 14.5L7.5 10l2.5 2.5L13 9.5l3.5 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 16.5h13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'),
    invoices: svg(
        '<path d="M6 3.5h8l2 2v11a1 1 0 01-1 1H5a1 1 0 01-1-1v-12a1 1 0 011-1z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
        '<path d="M14 3.5v2.5H16M7 9h6M7 12h6M7 15h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'
    ),
    collections: svg('<circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/><path d="M10 6.5v3.5l2.5 1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'),
    board: svg(
        '<rect x="3.5" y="4" width="4" height="12" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
        '<rect x="8.75" y="7" width="4" height="9" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
        '<rect x="14" y="5.5" width="2.5" height="10.5" rx="1" stroke="currentColor" stroke-width="1.4"/>'
    ),
    reports: svg(
        '<path d="M4.5 15.5V11M8.5 15.5V8M12.5 15.5V10M16.5 15.5V6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '<path d="M3.5 16.5h13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'
    ),
    accounts: svg(
        '<path d="M4 16.5V8.5l6-4.5 6 4.5v8" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
        '<path d="M7.5 16.5v-5h5v5" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>'
    ),
    contacts: svg(
        '<circle cx="8" cy="8" r="2.5" stroke="currentColor" stroke-width="1.4"/>' +
        '<path d="M3.5 16c0-2.5 2-4.5 4.5-4.5S12.5 13.5 12.5 16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
        '<circle cx="13.5" cy="7.5" r="2" stroke="currentColor" stroke-width="1.3"/>' +
        '<path d="M16.5 15.5c0-2-1.4-3.5-3-3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
    ),
    goals: svg(
        '<circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/>' +
        '<circle cx="10" cy="10" r="3" stroke="currentColor" stroke-width="1.4"/>' +
        '<circle cx="10" cy="10" r="0.8" fill="currentColor"/>' +
        '<path d="M10 3.5V1.5M14.5 5.5l1.5-1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'
    ),
    commissions: svg('<circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.4"/><path d="M10 6.5v6M8 8.5h2.75a1.25 1.25 0 010 2.5H9.25a1.25 1.25 0 000 2.5H12" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>'),
    schedule: svg('<rect x="3.5" y="4.5" width="13" height="12" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M3.5 8.5h13M7 2.5v3M13 2.5v3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'),
    calendar: svg('<rect x="3.5" y="4.5" width="13" height="12" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M3.5 8.5h13M7 2.5v3M13 2.5v3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M7.5 12h2M11 12h2M7.5 14.5h5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>'),
    users: svg(
        '<circle cx="10" cy="7" r="3" stroke="currentColor" stroke-width="1.4"/>' +
        '<path d="M4.5 17c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'
    ),
    integrations: svg(
        '<path d="M5 4.5v11M10 4.5v11M15 4.5v11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
        '<circle cx="5" cy="8.5" r="1.5" fill="currentColor"/>' +
        '<circle cx="10" cy="12" r="1.5" fill="currentColor"/>' +
        '<circle cx="15" cy="7" r="1.5" fill="currentColor"/>'
    ),
    permissions: svg(
        '<path d="M10 3l5 2v4c0 3-2.2 5.2-5 6.2-2.8-1-5-3.2-5-6.2V5l5-2z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
        '<path d="M7.6 10l1.7 1.7L12.6 8.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>'
    ),
    dataManagement: svg(
        '<path d="M4 5.5h12M6 8.5h8M8 11.5h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
        '<path d="M5 3.5h10l1.5 2v10.5a1 1 0 01-1 1H4.5a1 1 0 01-1-1V5.5L5 3.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>'
    )
};
